import { Component, Input, OnInit } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { WishlistService } from '../../../../shared/services/wishlist.service';
import { RootService } from '../../../../shared/services/root.service';
import { StoreService } from '@app/shared/services/store.service';
import { DirectionService } from '@app/shared/services/direction.service';
import { environment } from '@environments/environment';
import { CompareService } from '@app/shared/services/compare.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Product } from '@app/shared/interfaces/product';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
interface Feature {
    name: string;
    values: { [productId: number]: string };
}
@Component({
    selector: 'app-header-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

    @Input() departments = true;
    @Input() logo = false;
    @Input() search = false;
    logoUrl = 'assets/images/logos/';
    logoName = 'logo_';

    searchForm: FormGroup;
    keyword = '';

    constructor(
        public root: RootService,
        public cart: CartService,
        public wishlist: WishlistService,
        public store: StoreService,
        public compare: CompareService,
        private formBuilder: FormBuilder,
        private router: Router

    ) {
        this.logoUrl += environment.project + '/' + this.logoName + localStorage.getItem('lan').toLowerCase() + '.png';

        this.searchForm = this.formBuilder.group({ keyword: ['', Validators.required] });
    }
    ngOnInit(): void {
    }

    navigated($event) {
        console.log($event);
    }

    onSubmit(e) {
        console.log('search keyword : ', this.keyword);
        this.router.navigate(['/shop/search/', this.keyword]);
    }

    handleKeyUp(e) {
        if (e.keyCode === 13) {
            this.onSubmit(e);
        }
    }

}
